export enum DocumentApprovalStatus {
  pending = 1,
  approved = 2,
  rejected = 3,
  uploaded = 4,
  reuploaded = 5,
  updated = 6,
  details_added = 7,
  mark_as_na = 8,
}

export const DocumentApprovalStatusText: Record<
  DocumentApprovalStatus,
  string
> = {
  [DocumentApprovalStatus.pending]: "Pending",
  [DocumentApprovalStatus.approved]: "Approved",
  [DocumentApprovalStatus.rejected]: "Rejected",
  [DocumentApprovalStatus.uploaded]: "Uploaded",
  [DocumentApprovalStatus.reuploaded]: "Reuploaded",
  [DocumentApprovalStatus.updated]: "Updated",
  [DocumentApprovalStatus.details_added]: "Added",
  [DocumentApprovalStatus.mark_as_na]: "Mark as NA",
};

export const getDocumentApprovalStatusStyle = (
  status: DocumentApprovalStatus,
): { bgColor: string; textColor: string; dotColor: string } => {
  switch (status) {
    case DocumentApprovalStatus.pending:
      return {
        bgColor: "tw-bg-[#F5F5F5]",
        textColor: "tw-text-[#414651]",
        dotColor: "tw-bg-[#717680]",
      };
    case DocumentApprovalStatus.details_added:
      return {
        bgColor: "tw-bg-[#EFF6FF]",
        textColor: "tw-text-[#000]",
        dotColor: "tw-bg-[#717680]",
      };
    case DocumentApprovalStatus.approved:
      return {
        bgColor: "tw-bg-[#ECFDF3]",
        textColor: "tw-text-[#027A48]",
        dotColor: "tw-bg-[#12B76A]",
      };
    case DocumentApprovalStatus.rejected:
      return {
        bgColor: "tw-bg-[#FDD4D2]",
        textColor: "tw-text-[#B54708]",
        dotColor: "tw-bg-[#F04438]",
      };
    case DocumentApprovalStatus.mark_as_na:
      return {
        bgColor: "tw-bg-[#FDD4D2]",
        textColor: "tw-text-[#B54708]",
        dotColor: "tw-bg-[#F04438]",
      };
    case DocumentApprovalStatus.uploaded:
      return {
        bgColor: "tw-bg-[#FFF9E6]",
        textColor: "tw-text-[#000]",
        dotColor: "tw-bg-[#717680]",
      };
    case DocumentApprovalStatus.reuploaded:
      return {
        bgColor: "tw-bg-[#EFF6FF]",
        textColor: "tw-text-[#000]",
        dotColor: "tw-bg-[#717680]",
      };
    case DocumentApprovalStatus.updated:
      return {
        bgColor: "tw-bg-[#fff]",
        textColor: "tw-text-[#000]",
        dotColor: "tw-bg-[#717680]",
      };
    default:
      return {
        bgColor: "tw-bg-[#F5F5F5]",
        textColor: "tw-text-[#414651]",
        dotColor: "tw-bg-[#667085]",
      };
  }
};
